
    const html = "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=modal-content uib-modal-transclude></div></div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/modal/window.html', html);
    }]);
    module.exports = 'uib/template/modal/window.html';
  